import { useCallback, useState } from 'react';
import { useStudioMobileViewport } from './useStudioMobileViewport';

export const useCardPressHoldVideo = () => {
	const isMobile = useStudioMobileViewport();
	const [activeKey, setActiveKey] = useState(null);

	const isCardActive = useCallback((key) => activeKey === key, [activeKey]);

	const getCardVideoProps = useCallback(
		(key) => {
			if (isMobile) {
				return {
					onTouchStart: () => setActiveKey(key),
					onTouchEnd: () => setActiveKey(null),
					onTouchCancel: () => setActiveKey(null),
				};
			}

			return {
				onMouseEnter: () => setActiveKey(key),
				onMouseLeave: () => setActiveKey(null),
			};
		},
		[isMobile],
	);

	return { isCardActive, getCardVideoProps };
};
